import { Schema } from "@effect/schema";
import { Address } from "../address";
import { ProtocolKey } from "../protocol";
import { Usd } from "../usd";

export type StaticMarket = typeof StaticMarket.Type;
export type StaticMarketEncoded = typeof StaticMarket.Encoded;

export const StaticMarket = Schema.Struct({
  protocolKey: ProtocolKey,
  marketAddress: Address,
  isDeprecated: Schema.Boolean,
  rawSymbol: Schema.String,
  lastTvlUsd: Schema.NullOr(Usd),
}).annotations({ identifier: "StaticMarket" });
